angular.module("digitalLeasing.module").component("bankTable", {
  templateUrl: "ng/components/digitalLeasing/vendorSelection/bankTable/bankTable.view.html",
  bindings: {
    list: "<",
    containerClass: "@",
    onBankSelected: "&?",
    callNextStep:"&"
  },
  controllerAs: "bankTableCtrl",
  controller: BankTableCtrl
});

function BankTableCtrl(
  Bank,
  $rootScope) {

  var self = this;

  self.$onInit = function () {
    self.$rootScope =$rootScope;
    if (self.list && self.list.length == 1) {
      self.select(0);
    }
    console.info("selected is:", self.selected);
  }

  self.isRowSelected = function (index) {
    if (self.selected && self.list[index].filiale.ndg == self.selected.ndg) {
      return true;
    }
    return false;
  }

  self.select = function (index) {
    self.selected = self.list[index].filiale
    self.onBankSelected({
      bank: Bank.build(self.selected)
    })
    console.log("BANK: ", self.selected);
  }

  self.doubleClick = function(index){
    self.$rootScope.disableDoubleClick= true;
    self.callNextStep();
  }

}